import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

const renderOptions = (options) =>
  options.map((option) => (
    <option key={option.value} value={option.value}>
      {option.label}
    </option>
  ));

/**
 * Select of a FilterBar: the label is the empty option and the aria-label. `options` is a list of { value, label };
 * `groups` ({ label, options }[]) renders optgroups instead.
 */
export function FilterSelect({ name, label, value, options = [], groups, onChange }) {
  return (
    <label className="crm-rollo__field crm-rollo__field--select">
      <span className="crm-rollo__sr-only">{label}</span>
      <select
        className={`crm-rollo__select${value ? " is-set" : ""}`}
        aria-label={label}
        value={value}
        onChange={(event) => onChange(name, event.target.value)}
      >
        <option value="">{label}</option>
        {groups
          ? groups.map((group) => (
              <optgroup key={group.label} label={group.label}>
                {renderOptions(group.options)}
              </optgroup>
            ))
          : renderOptions(options)}
      </select>
    </label>
  );
}

// Date range of a FilterBar ("Creada", "Cierre"): both days included, never after today.
export function DateRange({ label, fromKey, toKey, filters, today, onChange }) {
  return (
    <div className="crm-rollo__range" role="group" aria-label={label}>
      <span className="crm-rollo__range-label" aria-hidden="true">
        {label}
      </span>
      <input
        type="date"
        className={`crm-rollo__input${filters[fromKey] ? " is-set" : ""}`}
        aria-label={`${label} desde`}
        value={filters[fromKey]}
        max={filters[toKey] || today}
        onChange={(event) => onChange(fromKey, event.target.value)}
      />
      <span className="crm-rollo__range-sep" aria-hidden="true">
        –
      </span>
      <input
        type="date"
        className={`crm-rollo__input${filters[toKey] ? " is-set" : ""}`}
        aria-label={`${label} hasta`}
        value={filters[toKey]}
        min={filters[fromKey] || undefined}
        max={today}
        onChange={(event) => onChange(toKey, event.target.value)}
      />
    </div>
  );
}

// Free search of a FilterBar.
export function SearchField({ label, value, onChange }) {
  return (
    <label className="crm-rollo__field crm-rollo__search">
      <FontAwesomeIcon icon={faMagnifyingGlass} className="crm-rollo__search-ico" aria-hidden="true" />
      <input
        className="crm-rollo__input"
        type="search"
        value={value}
        placeholder={label}
        aria-label={label}
        onChange={(event) => onChange(event.target.value)}
      />
    </label>
  );
}
